import React from 'react';
import FormLogin from '../../component/FormLogin';

class LoginPageContainer extends React.Component {
  render() {
    return (
      <div>
        <FormLogin />
      </div>
    );
  }
}

export default LoginPageContainer;
